class TableGridErrorReportCellController {
  constructor(sourceErrorsService) {
    this.name = 'tableGridErrorReportCell';
    this.sourceErrorsService = sourceErrorsService;
    this.areErrors = false;
  }

  getErrors() {
    this.sourceErrorsService.getErrors(this.batchId)
      .then(this.onSourceErrorsReceived.bind(this));
  }

  onSourceErrorsReceived(response) {
    let sourceErrors = response.data.content;
    this.areErrors = (sourceErrors.length > 0);
  }

  isCancelable() {
    return this.status !== 'COMPLETE' && this.status !== 'FAILED' && this.status !== 'CANCELLED';
  }

}

TableGridErrorReportCellController.$inject = ['sourceErrorsService'];

export default TableGridErrorReportCellController;



// WEBPACK FOOTER //
// ./app/components/tableGridErrorReportCell/tableGridErrorReportCell.controller.js